/** @param {import('react').SVGProps<SVGSVGElement>} props */
function InstallAppIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v10m0 0l3.5-3.5M12 13l-3.5-3.5M5 15v3a2 2 0 002 2h10a2 2 0 002-2v-3"
      />
    </svg>
  );
}

/**
 * Botão compacto (só ícone) — no Android com prompt nativo, instala direto ao tocar.
 * @param {{
 *   canShowInstall: boolean,
 *   canInstallNative?: boolean,
 *   onInstall: () => void,
 * }} props
 */
export function StorePwaInstallButton({ canShowInstall, canInstallNative = false, onInstall }) {
  if (!canShowInstall) return null;

  const title = canInstallNative ? 'Instalar app agora' : 'Instalar app na tela inicial';

  return (
    <button
      type="button"
      onClick={onInstall}
      className={`relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border text-zinc-600 transition sm:h-10 sm:w-10 dark:text-zinc-300 ${
        canInstallNative
          ? 'border-[rgb(var(--st-rgb)/0.45)] bg-[rgb(var(--st-rgb)/0.1)] text-[var(--st-700)] hover:border-[rgb(var(--st-rgb)/0.55)] hover:bg-[rgb(var(--st-rgb)/0.16)] dark:text-[var(--st-400)]'
          : 'border-zinc-200 hover:border-[rgb(var(--st-rgb)/0.4)] hover:bg-[rgb(var(--st-rgb)/0.08)] hover:text-[var(--st-700)] dark:border-zinc-600 dark:hover:border-[rgb(var(--st-rgb)/0.35)] dark:hover:bg-zinc-800/90 dark:hover:text-[var(--st-400)]'
      }`}
      aria-label={title}
      title={title}
    >
      <InstallAppIcon className="h-[18px] w-[18px] sm:h-5 sm:w-5" />
      {canInstallNative ? (
        <span
          className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-[var(--st-500)] ring-2 ring-white dark:ring-zinc-900"
          aria-hidden
        />
      ) : null}
    </button>
  );
}
